import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button, Input
} from 'reactstrap';


import Isvg from 'react-inlinesvg';

import webDocLogo from '../../../assets/images/webdoc-logo.png';
import infoIcon from "../../../assets/svg/link-new-tab.svg";

class WebDocInfo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }



    componentDidMount() {


    }



    render() {


        return (
            <button className='webdoc-button-container'>
                <div className={this.props.bottomTooltip ? 'button-elements-tooltip bottom-tooltip' : 'button-elements-tooltip'}>
                    <Isvg src={infoIcon} style={{ width: 25 }} />
                    <div className='tooltip-text' style={{ minWidth: 300, bottom: 29 }}>{'Only changes and bookings made in Curoflow notify patients. Bookings and changes made in Webdoc will not trigger any notifications. Chat and video calls always send notifications.'.translate(this.props.lang)}</div>
                </div>
                <img src={webDocLogo} />
                {'CREATED IN WEBDOC'.translate(this.props.lang)}
            </button>


        )
    }
}

export default WebDocInfo;